export interface IRole {
    Id: string;
    Name: string;
    Description?: string;
    OrganizationId?: string | null;
    OrganizationName?: string | null;
    IsDefault?: boolean | number;
    CreatedAt?: string;
    UpdatedAt?: string;
}

/** Platform-wide default roles — not editable or deletable. */
export const DEFAULT_PLATFORM_ROLE_IDS = [
    "rol-admin-owner",
    "rol-install",
    "rol-production",
    "rol-sales",
    "rol-super-admin",
] as const;

export const SUPER_ADMIN_ROLE_ID = "rol-super-admin";

export function isDefaultPlatformRole(role: Pick<IRole, "Id" | "OrganizationId" | "IsDefault">): boolean {
    if (role.IsDefault === true || role.IsDefault === 1) return true;
    if (role.OrganizationId == null || role.OrganizationId === "") return true;
    return (DEFAULT_PLATFORM_ROLE_IDS as readonly string[]).includes(role.Id);
}
